import get from 'lodash/get';
import { useQuery } from '@sde/widgets-core/src/tools/useQuery';
import UPDATE_TERMS_OF_USE_QUERY from './UpdateTermsOfUse.gql';

const parseResult = (result) => {
  const initialState = {
    updatedStatus: false,
  };

  const status = get(result, 'core.updateTermsOfUseStatus');

  return {
    ...initialState,
    ...status,
  };
};

export const useUpdateTermsOfUseQuery = (options) => {
  const [queryResult, queryAction] = useQuery(UPDATE_TERMS_OF_USE_QUERY, {
    ...options,
    onCompleted: (result) => {
      if (options.onCompleted) {
        options.onCompleted(parseResult(result.body.data));
      }
    },
  });

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
